/**
 * FilePreviewList - Horizontal list of file chips above input.
 */

import { FilePreviewChip, type FileAttachment } from './FilePreviewChip'

interface FilePreviewListProps {
  attachments: FileAttachment[]
  onRemove: (id: string) => void
}

export function FilePreviewList({ attachments, onRemove }: FilePreviewListProps) {
  if (attachments.length === 0) return null

  return (
    <div className="flex flex-wrap gap-2 px-4 py-2 border-b border-surface-border bg-surface/30">
      {attachments.map((attachment) => (
        <FilePreviewChip
          key={attachment.id}
          attachment={attachment}
          onRemove={onRemove}
        />
      ))}
    </div>
  )
}

export default FilePreviewList
